import React, { useState, useEffect } from 'react'
import Input from '../Input'
import Modal from '../Modal'
import Button from '../Button';
import ValidateAuth from "../../libs/validation/invite-validation";
import useFormValidation from "../../libs/validation/formvalidation";
import { usePost } from "../../libs/service/api";
import cookie from "../../libs/cookie/client";
const InviteModal = props => {
    const [enabled, setEnabled] = useState(props.isVisible)
    const [userid, setUserid] = useState(cookie.getItem("userid"))
    const [needsAssesmentID, setNeedsAssesmentID] = useState(cookie.getItem("needsassesmentid"))
    const INITIAL_STATE = {
        email: "",
        name: ""
    };
    const closeTrigger = (e) => {
        props.onCloseTrigger()
    }

    const OnSuccess = () => {
        usePost('/commonapi/shareteam',
            [{
                "key": "NeedsAssesmentID",
                "value": parseInt(needsAssesmentID)
            },
            {
                "key": "EmailID",
                "value": values.email
            },
            {
                "key": "Name",
                "value": values.name
            },
            {
                "key": "RightsLevel",
                "value": "Admin"
            },
            {
                "key": "userid",
                "value": parseInt(userid)
            }]).then(res => {
                if (!res.ErrorState) {
                    props.onCloseTrigger()
                }
            });

    }
    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        isSubmitting
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);
    useEffect(() => {
        setEnabled(props.isVisible)
        setNeedsAssesmentID(cookie.getItem("needsassesmentid"))
        setUserid(cookie.getItem("userid"))
    }, [props.isVisible])
    return (
        <Modal isOpen={enabled} closeTrigger={() => { closeTrigger() }} size="small">
            <div className="flex justify-between text-primary font-semibold pb-4 border-b border-vp-lightbrown" >
                <h4>Invite (1)</h4>
                <button className="font-semibold" onClick={() => { closeTrigger() }}>Close</button>
            </div>
            <form className="account-form" onSubmit={handleSubmit}>
                <div className="py-4">

                    <Input label="" type="text" placeholder="Type Name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="name"
                        autoComplete="off"
                        defaultValue={values.name}
                        error={errors.name}
                        haserror={errors.name ? 1 : 0}
                    />
                </div>
                <div className="py-4">

                    <Input label="" type="email" placeholder="Type E-mail"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="email"
                        autoComplete="off"
                        defaultValue={values.email}
                        error={errors.email}
                        haserror={errors.email ? 1 : 0}
                    />
                </div>
                <div className="flex">
                    <button type="submit" onClick={props.onClick} className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-48 mr-4">
                        Invite
                    </button>
                    {/* <Button btnStyle="primary" text="Invite" extraClasses="w-48 mr-4" /> */}
                    <Button btnStyle="primary-outline" onClick={() => { closeTrigger() }} text="Cancel" extraClasses="w-48" />
                </div>
            </form>

        </Modal>
    )
}

export default InviteModal
